import PropTypes from "prop-types";
import { XAxis, YAxis, Tooltip, ResponsiveContainer, BarChart, Bar, CartesianGrid } from "recharts";
import getRandomColor from "../../utils/randomColors";
import CustomizedAxisTick from "./customTick";
import CustomizedLabel from "./customLabel";

const MyBar = ({ data, width, yunit }) => {
  const keys = Object.keys(data[0]).filter((k) => k !== "name");

  return (
    <ResponsiveContainer width={width} height="100%">
      <BarChart width={730} height={250} data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" padding={{ left: 15, right: 15 }} tick={<CustomizedAxisTick />} />
        <YAxis allowDecimals={false} unit={yunit} domain={["auto", "auto"]} />
        <Tooltip />
        {keys.map((key, index) => (
          <Bar
            // eslint-disable-next-line react/no-array-index-key
            key={key + index}
            dataKey={key}
            fill={getRandomColor(key)}
            label={<CustomizedLabel />}
          />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
};

MyBar.defaultProps = {
  data: [],
  width: 300,
  yunit: "",
};

MyBar.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  width: PropTypes.number,
  yunit: PropTypes.string,
};
export default MyBar;
